import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { getProperty } from '@go-client/lib/api/property';
import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const VenueTemplateLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (logFields.property) {
          const property =
            typeof logFields.property === 'object'
              ? logFields.property
              : await getProperty(logFields.property);

          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'name',
              to: 'property',
            },
          ]);

          setLogFields({ ...logFields, ...propertyFields });
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
